module.exports = __webpack_public_path__ + "assets/afe1cf813c6c55312fcca733bd9d234d.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/resources/icons/icons-20.ttf
// module id = 3633
// module chunks = 0